import React from 'react';
import {Box, Stack, Typography} from '@mui/material';
import {coverageScoreColor, coverageTrackColor} from '../coverageScoreColor';

const CoverageBar = ({
    value,
    label,
    showValue = true,
    notApplicable = false,
    height = 3,
    sx,
}) => {
    if (notApplicable || value == null) {
        return (
            <Box sx={sx}>
                {(label || showValue) && (
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="baseline"
                        sx={{mb: 0.75}}
                    >
                        {label ? (
                            <Typography
                                variant="caption"
                                sx={{
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.08em',
                                    color: 'text.disabled',
                                    fontWeight: 400,
                                    fontSize: '0.7rem',
                                }}
                            >
                                {label}
                            </Typography>
                        ) : (
                            <span/>
                        )}
                        {showValue && (
                            <Typography
                                variant="caption"
                                sx={{
                                    color: 'text.secondary',
                                    fontWeight: 500,
                                    fontSize: '0.75rem',
                                    fontFamily: 'Roboto Mono, monospace',
                                }}
                            >
                                N/A
                            </Typography>
                        )}
                    </Stack>
                )}
            </Box>
        );
    }
    const pct = Math.min(100, Math.max(0, Number(value)));
    const rounded = Math.round(pct);
    const fillColor = coverageScoreColor(pct);
    const trackColor = coverageTrackColor(pct);

    return (
        <Box sx={sx}>
            {(label || showValue) && (
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="baseline"
                    sx={{mb: 0.75}}
                >
                    {label ? (
                        <Typography
                            variant="caption"
                            sx={{
                                textTransform: 'uppercase',
                                letterSpacing: '0.08em',
                                color: 'text.disabled',
                                fontWeight: 400,
                                fontSize: '0.7rem',
                            }}
                        >
                            {label}
                        </Typography>
                    ) : (
                        <span/>
                    )}
                    {showValue && (
                        <Typography
                            variant="caption"
                            sx={{
                                color: fillColor,
                                fontWeight: 500,
                                fontSize: '0.75rem',
                                fontFamily: 'Roboto Mono, monospace',
                            }}
                        >
                            {rounded}%
                        </Typography>
                    )}
                </Stack>
            )}
            <Box
                sx={{
                    height,
                    width: '100%',
                    bgcolor: trackColor,
                    borderRadius: 0,
                }}
            >
                {pct > 0 && (
                    <Box
                        sx={{
                            height: '100%',
                            width: `${pct}%`,
                            bgcolor: fillColor,
                            borderRadius: 0,
                        }}
                    />
                )}
            </Box>
        </Box>
    );
};

export default CoverageBar;
